// extracted by mini-css-extract-plugin
export default {"showReceiverNameLabel":"tXwYG1DMqkmcJsTGpmn7"};